var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Drag6 = function Drag6(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 6 10' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M0 0h2v2H0zm0 4h2v2H0zm0 4h2v2H0zm4-8h2v2H4zm0 4h2v2H4zm0 4h2v2H4z', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Drag6;
//# sourceMappingURL=Drag6.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Drag6.js